//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "topological",
  props: {
    device: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  data() {
    return {
      showList: []
    }
  },
  methods: {
    show(index) {
      this.$set(this.showList, index, !this.showList[index])
    },
    showRouteOrArp(index, key) {
      this.$set(this.device[index], key, !this.device[index][key])
    }
  },
  mounted() {
    this.device.forEach(item => {
      item.arpList = item.arpList.map(arp => {
        if (arp.tempid) {
          arp.color = '#4BF54BFF'
        }
        if (arp.alarm) {
          arp.color = '#E32020FF'
        }
        return arp
      })
      this.showList.push(false)
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/topological.vue